import { statesOptions } from '@/utils/common'

export function getStateName(stateCode: string): string {
  const match = statesOptions.find((s: string) => s.endsWith(` ${stateCode}`))
  if (!match) return stateCode
  return match.replace(` ${stateCode}`, '')
}
